import React, { useEffect, useState } from 'react';
import styles from './ActionProgress.module.css';
import useTheme from 'config/useTheme';

const ActionProgress = ({ stepInterval = 500 }) => {
    const { dark } = useTheme();
    const [percentage, setPercentage] = useState(0);
    const totalSegments = 10;

    const fillColors = [
        '#b3e5fc',
        '#81d4fa',
        '#4fc3f7',
        '#29b6f6',
        '#03a9f4',
        '#039be5',
        '#0288d1',
        '#0277bd',
        '#01579b',
        '#004c8c'
    ];

    useEffect(() => {
        let interval = setInterval(() => {
            setPercentage(prev => {
                if (prev < 99) {
                    return prev + 1;
                } else {
                    clearInterval(interval);
                    return prev;
                }
            });
        }, stepInterval);

        return () => clearInterval(interval);
    }, [stepInterval]);

    const activeSegments = Math.round((percentage / 100) * totalSegments);

    return (
        <div className={`${styles.action_progress} ${dark ? styles.dark : ''}`}>
            <div className={styles.bar}>
                {[...Array(totalSegments)].map((_, i) => (
                    <div
                        key={i}
                        className={styles.segment}
                        style={{
                            zIndex: totalSegments - i,
                            background: i < activeSegments ? fillColors[i] : ''
                        }}
                    />
                ))}
                <div className={styles.label}>{percentage}%</div>
            </div>
        </div>
    );
};

export default ActionProgress;